import { render, staticRenderFns } from "./spinner.vue?vue&type=template&id=8f4c274c&scoped=true"
var script = {}
import style0 from "./spinner.vue?vue&type=style&index=0&id=8f4c274c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f4c274c",
  null
  
)

export default component.exports